<template>
  <el-dialog
    :visible.sync="
      modal.open
    "
    :close-on-click-modal="false"
    :z-index="2002"
    :width="
      image ? 'auto' : '30rem'
    ">
    <div
      slot="title"
      class="
        dialog-title
      ">
      <b>
        {{ title }}
      </b>
    </div>
    <div
      v-if="
        image
      "
      class="image-wrap">
      <img
        class="image"
        :src="
          image
        "
        @error="
          (event) => imgError(event)
        "
      />
    </div>
    <p
      v-else
      class="content">
      {{ content }}
    </p>
  </el-dialog>
</template>

<script lang="js">

// Assets
import empty from '@/assets/images/admin/empty.png'

export default {
  props: {
    open: {
      type   : Boolean,
      default: false
    },
    title: {
      type   : String,
      default: null
    },
    content: {
      type   : String,
      default: null
    },
    image: {
      type   : String,
      default: null
    }
  },
  data() {
    return {
      modal: {
        open: this.open
      }
    }
  },
  watch: {
    open(open) {
      this.modal.open = open
    },
    'modal.open': function handleModalOpenChange(open) {
      this.$emit(
        'update:open', open
      )
    },
  },
  methods: {
    imgError(e) {
      e.target.src = empty
    }
  },
}

</script>

<style lang="css" scoped>

.content {
  margin-top : 0;
  padding    : var(--size-lg);
  padding-top: var(--size-sm);
  white-space: pre-line;
}

.image-wrap {
  display    : flex;
  align-items: center;
  min-width  : 20rem;
  padding    : var(--size-lg);
  padding-top: var(--size-sm);
}

.image {
  display      : block;
  width        : auto;
  max-width    : 100%;
  max-height   : 80svh;
  object-fit   : contain;
  border-radius: var(--size-xs);
}

</style>
